import { useImperativeHandle as g } from "react";
const m = (s, o, r, l, e) => {
  g(
    s,
    () => ({
      getActivator: () => o.elements.domReference,
      getFocusableActivator: e == null ? void 0 : e.getFocusableActivator,
      getContent: () => o.elements.floating,
      setShow: l.setShow,
      show: l.show,
      toggleAriaControls: r.toggleAriaControls
    }),
    [
      e == null ? void 0 : e.getFocusableActivator,
      l.setShow,
      l.show,
      r.toggleAriaControls,
      o.elements.domReference,
      o.elements.floating
    ]
  );
};
export {
  m as usePopoverImperativeHandle
};
